import { createSelectionTitleString } from "../support/helpers";

const mockVariants = [
  {
    id: 42188080480451,
    title: "Default",
    option1: "Default",
    option2: null,
    option3: null,
    sku: "",
    requires_shipping: true,
    taxable: true,
    featured_image: null,
    available: false,
    name: "Customised Bamford GMT",
    public_title: null,
    options: ["Default"],
    price: 116667,
    weight: 680,
    compare_at_price: null,
    inventory_management: "shopify",
    barcode: "",
  },
  {
    id: 42188080513219,
    title: "Titanium",
    option1: "Titanium",
    option2: null,
    option3: null,
    sku: "",
    requires_shipping: true,
    taxable: true,
    featured_image: null,
    available: true,
    name: "Customised Bamford GMT - Titanium",
    public_title: "Titanium",
    options: ["Titanium"],
    price: 125000,
    weight: 680,
    compare_at_price: null,
    inventory_management: null,
    barcode: "",
  },
];

export const getProductVariantsFromShopify = async () => {
  if (window.location.hostname === "localhost") {
    return mockVariants;
  }
  const response = await fetch("/products/customised-bamford-gmt.js");
  const data = await response.json();
  return data.variants;
};

export const addProductToCart = async (
  variant,
  finalConfiguration,
  imageUrl
) => {
  const properties = {};
  finalConfiguration.forEach((config) => {
    properties[config.title] = createSelectionTitleString(
      config.key,
      config.selectionText,
      config.selectionTitle
    );
  });

  properties["_imageUrl"] = imageUrl;

  const payload = {
    items: [
      {
        id: variant.id,
        quantity: 1,
        properties,
      },
    ],
  };
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};
